import React, { useState } from 'react';
import { IconButton, Stack } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

interface Props {
  content: string | React.JSX.Element;
  copyText: string;
}

const CopyToClipboard = (props: Props) => {
  const { content, copyText } = props;
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(copyText);
    setCopied(true);

    setTimeout(() => setCopied(false), 1500);
  };
  return (
    <Stack direction="row" spacing={1} gap={0.75} alignItems="center" width={'100%'}>
      {content}
      <IconButton
        onClick={e => {
          e.stopPropagation();
          handleCopy();
        }}
        size="small"
        color={copied ? 'success' : 'default'}
        sx={{ p: 0, m: 0 }}
      >
        <ContentCopyIcon sx={{ fontSize: 16 }} />
      </IconButton>
    </Stack>
  );
};

export default CopyToClipboard;
